import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CowTableComponent } from '../cow-table/cow-table.component';

@Component({
  selector: 'other-measurements',
  templateUrl: './measurements.component.html',
  imports: [CowTableComponent],
})
export class MeasurementsComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  public selectedDate: Date = new Date();

  ngOnInit() {
    const date = this.route.snapshot.queryParamMap.get('date');
    if (date) {
      this.selectedDate = new Date(date);
    }

    this.router.navigate([], { relativeTo: this.route, queryParams: {} });
  }
}
